(function () {
  const grid = document.getElementById('product-grid');
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  if (!grid || !sentinel) return;

  // The collection template puts id="product-grid" on the <ul> itself; the search
  // template puts it on a wrapper <div> with the <ul> inside. Find the actual list
  // either way, otherwise appended results land in the wrong element or nowhere.
  const listIn = (root) => {
    if (!root) return null;
    return root.tagName === 'UL' ? root : root.querySelector('ul.product-grid, ul.grid');
  };

  const list = listIn(grid);
  if (!list) return;

  let nextUrl = sentinel.dataset.nextUrl || grid.dataset.nextUrl;
  if (!nextUrl) { sentinel.remove(); return; }

  let loading = false;
  const loadOffset = 700;

  const loadMore = async () => {
    if (loading || !nextUrl) return;
    loading = true;
    sentinel.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('product-grid');
      const newList = listIn(newGrid);
      const newItems = newList ? newList.querySelectorAll(':scope > .grid__item') : [];
      newItems.forEach(item => list.appendChild(item));

      const newSentinel = doc.getElementById('infinite-scroll-sentinel');
      nextUrl = newSentinel ? newSentinel.dataset.nextUrl : (newGrid ? newGrid.dataset.nextUrl : null);
      grid.dataset.nextUrl = nextUrl || '';
      sentinel.dataset.nextUrl = nextUrl || '';

      if (!nextUrl) {
        observer.disconnect();
        window.removeEventListener('scroll', checkPosition);
        window.removeEventListener('resize', checkPosition);
        sentinel.remove();
      }
    } catch (e) {
      console.error('Infinite scroll failed:', e);
    } finally {
      loading = false;
      sentinel.classList.remove('is-loading');
      requestAnimationFrame(checkPosition);
    }
  };

  const checkPosition = () => {
    if (!nextUrl || loading || !sentinel.isConnected) return;
    const rect = sentinel.getBoundingClientRect();
    if (rect.top <= window.innerHeight + loadOffset) {
      loadMore();
    }
  };

  const observer = new IntersectionObserver(
    (entries) => { if (entries[0].isIntersecting) loadMore(); },
    { rootMargin: '300px' }
  );

  observer.observe(sentinel);
  window.addEventListener('scroll', checkPosition, { passive: true });
  window.addEventListener('resize', checkPosition);
  checkPosition();
})();
